interface ProfileAvatarProps {
  avatarUrl: string | null;
  fullName: string | null;
}

export const ProfileAvatar = ({ avatarUrl, fullName }: ProfileAvatarProps) => {
  return avatarUrl ? (
    <img
      src={avatarUrl}
      alt={fullName || ''}
      className="h-12 w-12 rounded-lg object-cover"
    />
  ) : (
    <div className="h-12 w-12 rounded-lg bg-muted flex items-center justify-center">
      <span className="text-lg font-semibold text-muted-foreground">
        {fullName?.[0] || '?'}
      </span>
    </div>
  );
};